import FormDeclarationComponent from './FormDeclaration/FormDeclaration'
import FormComponent from './Form/Form'

export const FormDeclaration = FormDeclarationComponent
export const Form = FormComponent
